import React from "react";
import PropTypes from "prop-types";
import SvgComponent from "./errorSvg";
import { Heading, VStack, Text, Box, Button } from "@chakra-ui/react";

const ErrorMsg = ({ title, message, showRefresh, children }) => {
  const onRefresh = () => {
    window.location.reload();
  };
  return (
    <VStack
      spacing={4}
      direction={"column"}
      flexGrow={1}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Box
        color={"brand.primary.400"}
        background={"#fff"}
        borderRadius={"999px"}
        border={"3px solid"}
        borderColor={"brand.primary.400"}
        p={1}
      >
        <SvgComponent height={80} />
      </Box>
      <Heading as={"h1"}>{title || "Oops! Something went wrong"}</Heading>
      {!message && !children && (
        <Text fontSize={"xl"} textAlign={"center"} px={10}>
          Please refresh to try again
        </Text>
      )}
      {message && (
        <Text fontSize={"xl"} textAlign={"center"} px={10}>
          {message}
        </Text>
      )}
      {children}
      {showRefresh && (
        <Button
          onClick={onRefresh}
          variant={"kioskPrimary"}
          data-testid={"refresh"}
        >
          Refresh
        </Button>
      )}
    </VStack>
  );
};

ErrorMsg.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
  showRefresh: PropTypes.bool,
  children: PropTypes.node,
};

export default ErrorMsg;
